import { useLang } from "@/LangContext";
import { Reveal, Chapter } from "@/components/Reveal";

const PHOTOS = [
  { src: "/assets/terreno-aereo-1.jpg", ratio: "aspect-[16/9]" },
  { src: "/assets/terreno-aereo-2.jpg", ratio: "aspect-[16/9]" },
  { src: "/assets/campo-actual-1.jpg", ratio: "aspect-[4/5]" },
  { src: "/assets/campo-actual-2.jpg", ratio: "aspect-[4/5]" },
];

export default function Transformation() {
  const { t } = useLang();

  return (
    <section
      id="areas"
      data-testid="transformation-section"
      className="relative border-t border-white/5 bg-[#0C0F16] py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Chapter number={t.trans.chapter} label={t.trans.label} />
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-10 font-display text-xl font-bold uppercase tracking-tight text-amber-400 sm:text-2xl">
            {t.trans.statement}
          </p>
          <h2 className="mt-4 max-w-4xl font-display text-3xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl">
            {t.trans.title}
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg">
            {t.trans.subtitle}
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <figure
            data-testid="current-state-video"
            className="mt-14 border border-white/10 bg-[#121620] p-2"
          >
            <div className="relative overflow-hidden">
              <video
                src="/assets/estado-actual.mp4"
                autoPlay
                muted
                loop
                playsInline
                controls
                className="max-h-[72vh] w-full bg-black object-cover"
              />
              <span className="absolute left-3 top-3 bg-[#0A0C10]/75 px-2.5 py-1 font-code text-[10px] uppercase tracking-[0.25em] text-amber-400 backdrop-blur-sm">
                {t.trans.videoLabel}
              </span>
            </div>
            <figcaption className="px-2 pb-2 pt-4 font-code text-[11px] uppercase tracking-[0.22em] text-slate-400">
              {t.trans.videoCaption}
            </figcaption>
          </figure>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2">
          {PHOTOS.map((photo, i) => (
            <Reveal key={photo.src} delay={i * 0.08}>
              <figure
                data-testid={`transformation-photo-${i + 1}`}
                className="group border border-white/10 bg-[#121620] p-2 transition-colors duration-500 hover:border-amber-400/40"
              >
                <div className={`relative overflow-hidden ${photo.ratio}`}>
                  <img
                    src={photo.src}
                    alt={t.trans.captions[i]}
                    loading="lazy"
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 bg-[#0A0C10]/75 px-2.5 py-1 font-code text-[10px] tracking-[0.25em] text-amber-400 backdrop-blur-sm">
                    REG. 0{i + 1}
                  </span>
                </div>
                <figcaption className="px-2 pb-2 pt-4 font-code text-[11px] uppercase tracking-[0.22em] text-slate-400">
                  {t.trans.captions[i]}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <p
            data-testid="transformation-note"
            className="mt-12 max-w-3xl border-l-2 border-amber-400 pl-6 text-sm leading-relaxed text-slate-300 sm:text-base"
          >
            {t.trans.note}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
